import { Button, Card, CardContent } from "@repo/ui";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

import { Footer } from "@/components/footer";
import { Nav } from "@/components/nav";

export function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <section className="mx-auto max-w-6xl px-4 md:px-6 pt-16 pb-12 grid md:grid-cols-2 gap-10 items-center">
        <div className="space-y-6">
          <p className="uppercase text-xs tracking-widest text-foreground/50">About</p>
          <h1 className="text-4xl md:text-5xl font-semibold leading-tight">
            Jenn Mueng — Software Developer
          </h1>
          <p className="text-lg text-foreground/80">Jenn is a great software dev.</p>
          <div className="flex items-center gap-3">
            <Link to="/contact">
              <Button className="h-10 px-6">
                Hire me <ArrowRight className="size-4 ml-2" />
              </Button>
            </Link>
            <Link to="/projects" className="text-foreground/80 hover:text-foreground">
              View projects
            </Link>
          </div>
          <ul className="mt-4 grid sm:grid-cols-2 gap-3 text-sm text-foreground/80">
            {[
              "Full-stack TypeScript",
              "Accessible, modern UI",
              "Performance-focused",
              "Clean architecture",
            ].map((t) => (
              <li key={t} className="flex items-center gap-2">
                <CheckCircle2 className="size-4 text-primary" />
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative">
          <div className="aspect-square rounded-2xl overflow-hidden border border-border bg-gradient-to-br from-purple-500/20 to-purple-900/10">
            <img
              src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=800"
              alt="Portrait of Jenn (placeholder)"
              className="w-full h-full object-cover mix-blend-luminosity"
            />
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 md:px-6 pb-16">
        <div className="grid md:grid-cols-3 gap-4">
          {["Frontend", "Backend", "DevOps"].map((k) => (
            <Card key={k} className="bg-card/60">
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold mb-2">{k}</h3>
                <p className="text-foreground/70">
                  Building reliable {k.toLowerCase()} solutions with a focus on clarity,
                  accessibility, and performance.
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
